import router from '@/router';
export function redirectToUnlock() {
  router.push('/unlock');
} 